import { STATE_CODES } from "constants/states"

export const DocumentTypes = {
  AADHAR: "AADHAR Card",
  PAN: "PAN Card",
  GST: "GST",
}

export const documents = [
  {
    kind: DocumentTypes.AADHAR,
    regexPattern: /^[0-9]{12}$/,
    message: "Please enter a valid Aadhar number",
  },
  {
    kind: DocumentTypes.PAN,
    regexPattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/,
    message: "Please enter a valid PAN",
  },
  {
    kind: DocumentTypes.GST,
    regexPattern:
      /^([0-9]{2})([A-Za-z0-9]{10})([0-9]){1}([Z]){1}([A-Za-z0-9]){1}$/,
    message: "Please enter a valid GST number ",
  },
]

export type ValidDocumentType = {
  documentKind: string
  documentNumber: string
  pan?: any
  state?: string
}

export const isValidDocument = ({
  documentKind,
  documentNumber,
  pan,
  state,
}: ValidDocumentType) => {
  const formattedState = state ? state.toUpperCase() : ""
  const documentValidator = Object.values(documents)?.find(doc => {
    return doc?.kind === documentKind
  })
  const regexPattern = documentValidator?.regexPattern
  const isValid = regexPattern ? regexPattern.test(documentNumber) : true

  if (documentKind === DocumentTypes.GST && isValid) {
    const matches = documentNumber.match(regexPattern)
    const [, stateCode, gstPan, entity, checksum] = matches

    if (!pan) {
      return "GST invalid. No PAN number available"
    }
    if (pan !== gstPan) {
      return "GST invalid. PAN number does not match."
    }
    if (!state) {
      return "Address not available"
    }
    const isValid =
      gstPan === pan &&
      stateCode ===
        STATE_CODES.find(a => {
          return a.state === formattedState
        })?.code

    return !isValid ? "State code does not match." : false
  }

  if (documentKind === DocumentTypes.AADHAR && isValid) {
    const isAadharValid = validateAadharChecksum(documentNumber)
    return isAadharValid ? false : documentValidator.message
  }

  return isValid ? false : documentValidator.message
}

var d = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
]
var p = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
]

var inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9]

const validateAadharChecksum = aadhar => {
  var aadhaarArray = aadhar.split("")
  var toCheckChecksum = aadhaarArray.pop()
  return generate(aadhaarArray) === parseInt(toCheckChecksum)
}

function generate(array) {
  var c = 0
  var invertedArray = array.reverse()
  for (var i = 0; i < invertedArray.length; i++) {
    c = d[c][p[(i + 1) % 8][invertedArray[i]]]
  }
  return inv[c]
}

export type InValidDocumentCheckType = {
  documents: any
  kycTypeIdentifier?: string
  idNumberIdentifier?: string
  state?: string
}
export const isInValidDocumentPresent = ({
  documents,
  kycTypeIdentifier = "kycType",
  idNumberIdentifier = "idNumber",
  state = "Maharashtra",
}: InValidDocumentCheckType) => {
  return documents
    ?.map(d => {
      const pan = documents?.find(doc => {
        return doc?.[kycTypeIdentifier]?.name === DocumentTypes.PAN
      })?.idNumber
      const isValid = !isValidDocument({
        documentKind: d?.[kycTypeIdentifier]?.name,
        documentNumber: d?.[idNumberIdentifier],
        pan: pan,
        state: state,
      })
      return Boolean(isValid)
    })
    ?.find(d => {
      return !d
    })
}
